import * as S from "sanctuary";
import { connect } from "react-redux";
import { getCurrentUserPermissions } from "./CurrentUser.state";
import { getCurrentUserRole } from "./CurrentUser.state";
import { ALL_PERMISSIONS } from "./constants";
import { RESEARCHER, userRolesHierarchy } from "@/sanctuary/typedefs";

const toFlags = (permissions) =>
  Object.entries(ALL_PERMISSIONS).reduce(
    (flagsSoFar, [key, value]) => ({
      ...flagsSoFar,
      [key]: permissions.includes(value),
    }),
    {}
  );

const mapStateToProps = (state) => {
  const userPermissions = S.fromMaybe([])(getCurrentUserPermissions(state));
  const permissionFlags = toFlags(userPermissions);
  const currentUserRole = S.pipe([
    S.fromMaybe(S.Right(RESEARCHER)),
    S.fromEither(RESEARCHER),
  ])(getCurrentUserRole(state));
  return {
    ...permissionFlags,
    currentUserRole,
    currentUsersAdministeredRoles: S.prop(currentUserRole)(userRolesHierarchy),
  };
};

const connectUserPermissions = (Component) => connect(mapStateToProps)(Component);

export default connectUserPermissions;
